/* eslint-disable */
import Long from 'long';
import _m0 from 'protobufjs/minimal';
import { PluginContainerData } from './common';
import { HTMLData_Source } from './plugin_html.enums';
export function hTMLData_SourceFromJSON(object) {
    switch (object) {
        case 0:
        case 'HTML':
            return HTMLData_Source.HTML;
        case 1:
        case 'ADSENSE':
            return HTMLData_Source.ADSENSE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return HTMLData_Source.UNRECOGNIZED;
    }
}
export function hTMLData_SourceToJSON(object) {
    switch (object) {
        case HTMLData_Source.HTML:
            return 'HTML';
        case HTMLData_Source.ADSENSE:
            return 'ADSENSE';
        default:
            return 'UNKNOWN';
    }
}
const baseHTMLData = { source: HTMLData_Source.HTML };
export const HTMLData = {
    fromJSON(object) {
        const message = Object.assign({}, baseHTMLData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.url = object.url !== undefined && object.url !== null ? String(object.url) : undefined;
        message.html =
            object.html !== undefined && object.html !== null ? String(object.html) : undefined;
        message.isAdsense =
            object.isAdsense !== undefined && object.isAdsense !== null
                ? Boolean(object.isAdsense)
                : undefined;
        message.source =
            object.source !== undefined && object.source !== null
                ? hTMLData_SourceFromJSON(object.source)
                : HTMLData_Source.HTML;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.url !== undefined && (obj.url = message.url);
        message.html !== undefined && (obj.html = message.html);
        message.isAdsense !== undefined && (obj.isAdsense = message.isAdsense);
        message.source !== undefined && (obj.source = hTMLData_SourceToJSON(message.source));
        return obj;
    },
};
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
//# sourceMappingURL=plugin_html.js.map